import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPartnerOnboardingContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PartnerOnboardingContainer" */
                '@perpay-web/fintech/components/containers/PartnerOnboardingContainer'
            ),
    );
